import React from 'react';
import { TextField,MenuItem} from '@mui/material';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import { FormControl,   } from '@material-ui/core';
const SelectNormal = ({ label, options, value, onChange, required, size, readOnly }) => {
  return (
    <>
      {required && <label>{label} <span style={{ color: 'red' }}>*</span></label>}
      <TextField
        label={label}
        fullWidth
        select
        size={size}
        value={value}
        onChange={onChange}
        margin="normal"
        InputProps={readOnly ? { readOnly: true } : {}}
      >
        {options.map((option) => (
          <MenuItem key={option.Value} value={option.Value}>
            {option.Label}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
};

const SelectNormalS = ({ label, options, value, onChange, required, size }) => {
  return (
    <>
     <FormControl fullWidth>
      {required && <label>{label} <span style={{ color: 'red' }}></span></label>}

      <TextField
        select
        label={label}

        fullWidth
        value={value}
        onChange={onChange}
        variant="outlined"
         margin="normal"

      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))}
      </TextField>
      </FormControl>
    </>
  );
}


const SelectSearch = ({ options, onChange, value, label, required, size  }) => {
  const selectedValue = value ? options.find(option => option.Value === value) : null;

  const handleChange = (event, selectedOption) => {
    onChange(selectedOption ? selectedOption.Value : null);
  };
  
  return (
    <>
      <Autocomplete
        options={options}
        getOptionLabel={(option) => option.Label}
        size={size}
        value={selectedValue}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label={required ? (
              <>
                {label} <span style={{ color: 'red' }}>*</span>
              </>
            ) : label}
            fullWidth
            margin="normal"
          />
        )}
      />
    </>
  );
};


const MultipleSelect = ({ options, onChange, value, label, required, size }) => {

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={value}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={value} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
        size={size}
      >
        {options.map((option) => (
          <MenuItem
            key={option.Value}
            value={option.Value}
          >
            {option.Label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export { SelectNormal, SelectSearch, MultipleSelect, SelectNormalS };
